class CollectionWithSlider extends HTMLElement {
  constructor() {
    super();

    this.slidesCount = +this.dataset.slides;
    this.slidesToShow = +this.dataset.slidesToShow;
    this.slidesToShowMobile = +this.dataset.slidesToShowMobile;
    this.$swiper = null;
    this._tabGroupEl = null;
    this._onTabShow = this._updateSwiper.bind(this);
  }

  get name() {
    return this.getAttribute('name');
  }

  connectedCallback() {
    this._init();
    this._handleTabchange();
  }

  disconnectedCallback() {
    this._tabGroupEl?.removeEventListener('sl-tab-show', this._onTabShow);
    this._tabGroupEl = null;

    if (this.$swiper && typeof this.$swiper.destroy === "function") {
      this.$swiper.destroy(true, true);
    }
    this.$swiper = null;
  }

  _init() {
    const swiperEl = this.querySelector(".js-collection-with-slider");
    const prevEl = this.querySelector(".featured-collection--icon-previous");
    const nextEl = this.querySelector(".featured-collection--icon-next");

    const option = {
      init: false,
      spaceBetween: 0,
      slidesPerView: this.slidesToShowMobile,
      preventClicks: false,
      preventClicksPropagation: false,
      slidesOffsetAfter: 0,
      slidesOffsetBefore: 0,
      centeredSlides: true,
      loop: true,
      loopAdditionalSlides: 2,
      navigation: { nextEl, prevEl },
      longSwipesRatio: 0.25,
      breakpoints: {
        640: { slidesPerView: 2 },
        990: { slidesPerView: 3 },
        1200: { slidesPerView: 4 },
        1400: { slidesPerView: this.slidesToShow },
        1800: { slidesPerView: this.slidesToShow },
      },
    };

    // Double the slides if needed before creating the Swiper
    this._doubleSlidesIfNeeded(swiperEl);

    this.$swiper = new Swiper(swiperEl, option);
    this.$swiper.on("afterInit", () => this._doInit());
    this.$swiper.on("resize", () => this._doInit());
    this.$swiper.init();
  }

  _doInit() {
    const imgWrapper = this.$swiper.el.querySelector(".card__media");
    if (imgWrapper) {
      const h = imgWrapper.getBoundingClientRect().height;
      this.style.setProperty("--media-height", `${h}px`);
    }
  }

  // If the original slides count is less than 9, double the slides
  _doubleSlidesIfNeeded(swiperEl) {
    const wrapper = swiperEl?.querySelector(".swiper-wrapper");
    if (!wrapper) return;

    // Clean up the previous cloned slides
    for (const n of wrapper.querySelectorAll(".js-dup-slide")) {
      n.remove();
    }

    // Only count the original slides
    const originals = Array.from(wrapper.children).filter(
      (n) => !n.classList.contains("js-dup-slide"),
    );
    const originalCount = originals.length;

    if (originalCount > 0 && originalCount < 9) {
      for (const node of originals) {
        const clone = node.cloneNode(true);
        clone.classList.add("js-dup-slide");
        clone.setAttribute("aria-hidden", "true");
        wrapper.appendChild(clone);
      }
    }
  }

  _handleTabchange() {
    const tabGroupEl = this.closest('sl-tab-group');

    if (!tabGroupEl || !this.$swiper) return;

    this._tabGroupEl = tabGroupEl;
    tabGroupEl.addEventListener('sl-tab-show', this._onTabShow);
  }

  _updateSwiper(event) {
    if (!this.$swiper) return;

    const tabName = event?.detail?.name || '';

    if (tabName === this.name) {
      this.$swiper.update();
    }
  }
}

customElements.define("collection-with-slider", CollectionWithSlider);
